const getProductMeasures = (product) => {
    const measures = [product.absorbency, product.length, product.style, product.size].filter(Boolean);

    return measures.join(' / ');
};

export { getProductMeasures };
